import { render, staticRenderFns } from "./DriverForm.vue?vue&type=template&id=54ed02a0&scoped=true"
import script from "./DriverForm.vue?vue&type=script&lang=js"
export * from "./DriverForm.vue?vue&type=script&lang=js"
import style0 from "./DriverForm.vue?vue&type=style&index=0&id=54ed02a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ed02a0",
  null
  
)

export default component.exports